import {
  CloseCircleOutlined,
  FlagOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { DetailsPageLayout } from '../../../components'
import {
  BadgeColors,
  compensationMatrixAnalysisValidationStatuses,
} from '../../../constants/constants'
import { compensationMatrixAnalysisPanels } from './Components/CompensationMatrixAnalysisSelectPanel'
import CompensationMatrixAnalysisSmartFunctionDetailsPageHeader from './Components/CompensationMatrixAnalysisSmartFunctionDetailsPageHeader'
import CompensationMatrixAnalysisSmartFunctionDetailsPageFilteringPanel from './panels/CompensationMatrixAnalysisSmartFunctionDetailsPageFilteringPanel'
import CompensationMatrixAnalysisSmartFunctionDetailsPageMatchingPanel from './panels/CompensationMatrixAnalysisSmartFunctionDetailsPageMatchingPanel'

export const compensationMatrixAnalysisBadgeStatusColorKeys = {
  [compensationMatrixAnalysisValidationStatuses.ERROR]: BadgeColors.ERROR,
  [compensationMatrixAnalysisValidationStatuses.SUCCESS]: BadgeColors.SUCCESS,
  [compensationMatrixAnalysisValidationStatuses.TO_REVIEW]: BadgeColors.WARNING,
}

export const compensationMatrixAnalysisValidationStatusToComponentMap = {
  [compensationMatrixAnalysisValidationStatuses.ERROR]: <CloseCircleOutlined />,
  [compensationMatrixAnalysisValidationStatuses.SUCCESS]: (
    <SafetyCertificateOutlined />
  ),
  [compensationMatrixAnalysisValidationStatuses.TO_REVIEW]: <FlagOutlined />,
}

const CompensationMatrixAnalysisSmartFunctionDetailsPage = () => {
  const { panel } = useParams()

  const panelIndex = useMemo(
    () => (panel === compensationMatrixAnalysisPanels.FILTERING ? 1 : 0),
    [panel]
  )
  const panels = useMemo(
    () => [
      <CompensationMatrixAnalysisSmartFunctionDetailsPageMatchingPanel />,
      <CompensationMatrixAnalysisSmartFunctionDetailsPageFilteringPanel />,
    ],
    []
  )

  return (
    <DetailsPageLayout>
      <CompensationMatrixAnalysisSmartFunctionDetailsPageHeader />
      {panels[panelIndex]}
    </DetailsPageLayout>
  )
}

export default CompensationMatrixAnalysisSmartFunctionDetailsPage
